// extracted by mini-css-extract-plugin
export default {"pageHeader":"BEozZLu_MKnUu5hOdYpB","noMargin":"sgeLqPiYN3Vp3Le7uECq","pageHeaderMobile":"yaG7GqYDZQR8Ln7FSigF","bottomBorder":"b1Qwzc6A66gcjhmHtNqq"};